<template>
  <div class="animated fadeIn">
    <div>
      <b-row>
        <b-col lg="6" v-if="detectionsEnabled">
          <b-card no-body class="oldscool" v-if="activeProjectPermissions.admin">
            <b-card-header header-class="">{{ $t('nav.detection_sets_list_title') }}</b-card-header>
            <b-card-body class="">
              <DetectionSetsCompact />
            </b-card-body>
          </b-card>
        </b-col>
        <b-col lg="6">
          <b-card no-body class="oldscool" v-if="activeProjectPermissions.admin">
            <b-card-header header-class="">{{ $t('nav.sample_sets_list_title') }}</b-card-header>
            <b-card-body class="">
              <SampleSetsCompact />
            </b-card-body>
          </b-card>
        </b-col>
        <b-col lg="6">
          <b-card no-body class="oldscool" v-if="activeProjectPermissions.admin">
            <b-card-header header-class="">{{ $t('nav.label_sets_list_title') }}</b-card-header>
            <b-card-body class="">
              <LabelSetsCompact />
            </b-card-body>
          </b-card>
        </b-col>
        <b-col lg="6" v-if="activeProjectPermissions.viewActivities">
          <b-card no-body class="oldscool">
            <b-card-header header-class="">{{ $dt('dashboard.activity_list', 'Activities') }}</b-card-header>
            <b-card-body class="">
              <ProjectAuditLogsCompact />
            </b-card-body>
          </b-card>
        </b-col>
        <b-col lg="6">
          <!-- <b-card no-body>
            <b-card-body class="">

            </b-card-body>
          </b-card> -->
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import DetectionSetsCompact from '@/views/DetectionSets/DetectionSetsCompact';
import SampleSetsCompact from '@/views/SampleSets/SampleSetsCompact';
import LabelSetsCompact from '@/views/LabelSets/LabelSetsCompact';
import ProjectAuditLogsCompact from '@/views/Administration/ProjectAuditLogsCompact';
import ENV from '@/config';

export default {
  name: 'dashboard',
  components: {
    DetectionSetsCompact, SampleSetsCompact, LabelSetsCompact, ProjectAuditLogsCompact
  },
  data() {
    return {
    };
  },
  computed: {

    // ...mapState('Auth', ['activeProjectId']),
    ...mapGetters('Auth', ['activeProjectPermissions']),
    detectionsEnabled() {
      return ENV.VUE_APP_DISABLE_DETECTIONS === "false";
    }
  },
  methods: {
  }
};
</script>

<style lang="scss">
.oldscool.oldscool {
  .card-header {
    position: relative;
    display: inline-block;
    width: auto;
    margin: calc(-1.25rem / 2) auto calc(-1.25rem / 2) 1.25rem;
    padding: 0 1em;
    border: 1px solid $gray-400;
    border-radius: 0.25rem;
  }
}
</style>
